module.exports = __webpack_public_path__ + "img/clarify.cf7b5ebc.svg";